module.exports = "/wp-content/plugins/farmacy/assets/js/fonts/glyphicons-halflings-regular-e18bbf611f2a2e43afc071aa2f4e1512.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/scss/fonts/bootstrap/glyphicons-halflings-regular.ttf
 ** module id = 227
 ** module chunks = 1 2 6 7 12 23 42 48 62
 **/